<template>
  <div>
    <div class="white-container" :key="$store.getters['resource/currentResource'].key">
      <trigger-view @save="saveEvent"/>
    </div>
  </div>
</template>

<script>
  import TriggerView from "./TriggersView.vue";

  export default {
    components: {
      TriggerView
    },
    middleware: 'auth',
    name: 'TriggersCreation',
    methods: {
      saveEvent(params) {
        this.postData('triggers/handlers', params, '/triggers');
      }
    }
  }
</script>